import { render, staticRenderFns } from "./breakfast.vue?vue&type=template&id=7f022210&scoped=true"
import script from "./breakfast.vue?vue&type=script&lang=js"
export * from "./breakfast.vue?vue&type=script&lang=js"
import style0 from "./breakfast.vue?vue&type=style&index=0&id=7f022210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f022210",
  null
  
)

export default component.exports